import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

import {
  SET_LABORATORIOS,
  SET_NOTICIAS,
  SET_OPCIONES_MENU,
  SET_BANNERS,
  SET_SERVICIOS,
  SET_SEDES,
  SET_QUIENES_SOMOS,
  SET_QUIENES_SOMOS_BTN,
  SET_POLITICAS,
  SET_MODELO_ATENCION,
  SET_CONTACTO,
} from './ApiActions';
import ApiContext from './ApiContext';
import ApiReducer from './ApiReducer';

import { fetchNoticias } from '../../services/noticias.service';
import {
  fetchBanners,
  fetchContent,
  fetchListaConfiguracion,
  fetchOpcionesAdmin,
  fetchPoliticas,
  fetchSedes,
} from '../../services/parameter.service';
import { fetchOpcionesMenu } from '../../services/parameter.service';
import axios from 'axios';

const ApiProvider = ({ children }) => {
  const initialState = {
    noticias: { isLoading: false, data: [], error: null },
    laboratorios: { isLoading: false, data: [], error: null },
    banners: {
      isLoading: false,
      data: { bannerList: [], doctorFamedic: '', menuBanners: [] },
      error: null,
    },
    opcionesMenu: {
      isLoading: false,
      data: { principal: [], secundario: [], servicios: [] },
      error: null,
    },
    servicios: { isLoading: false, data: [], error: null },
    sedes: { isLoading: false, data: [], error: null },
    quienesSomos: {
      isLoading: false,
      data: {
        mision: {},
        vision: {},
        historia: {},
        carruselUno: [],
        carruselDos: [],
      },
      error: null,
    },
    quienesSomosBtn: { isLoading: false, data: {}, error: null },
    politicas: { isLoading: false, data: [], error: null },
    modeloAtencion: { isLoading: false, data: {}, error: null },
    contacto: {
      isLoading: false,
      data: { dataAllContact: [], centroContacto: null, email: null, whatsapp: null, sedes: null },
      error: null,
    },
  };

  const [state, dispatch] = useReducer(ApiReducer, initialState);
  const {
    noticias,
    laboratorios,
    banners,
    opcionesMenu,
    servicios,
    sedes,
    quienesSomos,
    quienesSomosBtn,
    politicas,
    modeloAtencion,
    contacto,
  } = state;

  const getNoticias = async () => {
    dispatch({
      type: SET_NOTICIAS,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchNoticias();
      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_NOTICIAS,
        payload: { data: response?.data?.list, error: null },
      });
    } catch (error) {
      dispatch({ type: SET_NOTICIAS, payload: { error: error, data: [] } });
    } finally {
      dispatch({
        type: SET_NOTICIAS,
        payload: { isLoading: false },
      });
    }
  };

  const getLaboratorios = async () => {
    dispatch({
      type: SET_LABORATORIOS,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchContent('laboratorios');

      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_LABORATORIOS,
        payload: { data: response?.data?.list, error: null },
      });
    } catch (error) {
      dispatch({ type: SET_LABORATORIOS, payload: { error: error, data: [] } });
    } finally {
      dispatch({
        type: SET_LABORATORIOS,
        payload: { isLoading: false },
      });
    }
  };

  const getOpcionesMenu = () => {
    dispatch({
      type: SET_OPCIONES_MENU,
      payload: { isLoading: true },
    });

    const responseMenuSuperior = fetchOpcionesMenu({
      App: 'SI',
      Publica: 'SI',
      Tipo: 'MENU_SUPERIOR',
    });
    const responseMenuPpal = fetchOpcionesMenu({
      App: 'SI',
      Publica: 'SI',
      Tipo: 'MENU_PPAL',
    });
    const responseServicios = fetchOpcionesMenu({
      App: 'SI',
      Publica: 'SI',
      Tipo: 'MENUSERVICIOS',
    });

    axios
      .all([responseMenuSuperior, responseMenuPpal, responseServicios])
      .then(
        axios.spread((...data) => {
          const resMenuSuperior = data[0];
          const resMenuPpal = data[1];
          const resServicios = data[2];

          if (
            resMenuSuperior?.data?.apiResponse?.code !== 200 ||
            resMenuPpal?.data?.apiResponse?.code !== 200 ||
            resServicios?.data?.apiResponse?.code !== 200
          )
            return;

          dispatch({
            type: SET_OPCIONES_MENU,
            payload: {
              data: {
                principal: resMenuPpal.data.list,
                secundario: resMenuSuperior.data.list,
                servicios: resServicios.data.list,
              },
              error: null,
            },
          });
        })
      )
      .catch((error) => {
        dispatch({
          type: SET_OPCIONES_MENU,
          payload: {
            error: error,
            data: { principal: [], secundario: [], servicios: [] },
          },
        });
      })
      .finally(() => {
        dispatch({
          type: SET_OPCIONES_MENU,
          payload: { isLoading: false },
        });
      });
  };

  const getBanners = () => {
    dispatch({
      type: SET_BANNERS,
      payload: { isLoading: true },
    });

    const resBanners = fetchBanners({ app: true, estado: true });
    const resListConfiguration = fetchListaConfiguracion({
      key: 'URL_DOCTOR_FAMEDIC',
    });
    const resMenuBanner = fetchOpcionesMenu({
      App: 'SI',
      Publica: 'SI',
      Tipo: 'MENUBANNER',
    });

    axios
      .all([resBanners, resListConfiguration, resMenuBanner])
      .then(
        axios.spread((...data) => {
          const resBannerList = data[0];
          const resDoctorFamedic = data[1];
          const resMenuBanner = data[2];

          if (
            resBannerList?.data?.apiResponse?.code !== 200 ||
            resDoctorFamedic?.data?.apiResponse?.code !== 200 ||
            resMenuBanner?.data?.apiResponse?.code !== 200
          )
            return;

          dispatch({
            type: SET_BANNERS,
            payload: {
              data: {
                bannerList: resBannerList.data.list,
                doctorFamedic: resDoctorFamedic.data.list[0]?.value,
                menuBanners: resMenuBanner.data.list,
              },
              error: null,
            },
          });
        })
      )
      .catch((error) => {
        dispatch({
          type: SET_BANNERS,
          payload: {
            error: error,
            data: { bannerList: [], doctorFamedic: '', menuBanners: [] },
          },
        });
      })
      .finally(() => {
        dispatch({
          type: SET_BANNERS,
          payload: { isLoading: false },
        });
      });
  };

  const getServicios = async () => {
    dispatch({
      type: SET_SERVICIOS,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchOpcionesAdmin({
        publica: true,
        activa: true,
        tipo: 'SERVICIOS',
      });

      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_SERVICIOS,
        payload: { data: response?.data?.list, error: null },
      });
    } catch (error) {
      dispatch({ type: SET_SERVICIOS, payload: { error: error, data: [] } });
    } finally {
      dispatch({
        type: SET_SERVICIOS,
        payload: { isLoading: false },
      });
    }
  };

  const getSedes = async () => {
    dispatch({
      type: SET_SEDES,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchSedes({ app: true, estado: 'SI' });

      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_SEDES,
        payload: {
          data: response?.data?.list.filter((item) => item.activo),
          error: null,
        },
      });
    } catch (error) {
      dispatch({ type: SET_SEDES, payload: { error: error, data: [] } });
    } finally {
      dispatch({
        type: SET_SEDES,
        payload: { isLoading: false },
      });
    }
  };

  const getQuienesSomos = () => {
    dispatch({
      type: SET_QUIENES_SOMOS,
      payload: { isLoading: true },
    });

    const resMision = fetchContent('QUIENESSOMOSMISION');
    const resVision = fetchContent('QUIENESSOMOSVISION');
    const resHistoria = fetchContent('QUIENESSOMOSHISTORIA');
    const resCarruselUno = fetchContent('QUIENESSOMOSCARRUSELUNO');
    const resCarruselDos = fetchContent('QUIENESSOMOSCARRUSELDOS');

    axios
      .all([resMision, resVision, resHistoria, resCarruselUno, resCarruselDos])
      .then(
        axios.spread((...data) => {
          const resDataMision = data[0];
          const resDataVision = data[1];
          const resDataHistoria = data[2];
          const resDataCarruselUno = data[3];
          const resDataCarruselDos = data[4];

          dispatch({
            type: SET_QUIENES_SOMOS,
            payload: {
              data: {
                mision: resDataMision.data.list[0],
                vision: resDataVision.data.list[0],
                historia: resDataHistoria.data.list[0],
                carruselUno: resDataCarruselUno.data.list,
                carruselDos: resDataCarruselDos.data.list,
              },
              error: null,
            },
          });
        })
      )
      .catch((error) => {
        dispatch({
          type: SET_QUIENES_SOMOS,
          payload: {
            error: error,
            data: {
              mision: {},
              vision: {},
              historia: {},
              carruselUno: [],
              carruselDos: [],
            },
          },
        });
      })
      .finally(() => {
        dispatch({
          type: SET_QUIENES_SOMOS,
          payload: { isLoading: false },
        });
      });
  };

  const getPoliticas = async () => {
    dispatch({
      type: SET_POLITICAS,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchPoliticas();
      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_POLITICAS,
        payload: { data: response?.data?.list, error: null },
      });
    } catch (error) {
      dispatch({ type: SET_POLITICAS, payload: { error: error, data: [] } });
    } finally {
      dispatch({
        type: SET_POLITICAS,
        payload: { isLoading: false },
      });
    }
  };

  const getModeloAtencion = async () => {
    dispatch({
      type: SET_MODELO_ATENCION,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchContent('modeloatencion');
      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_MODELO_ATENCION,
        payload: { data: response?.data?.list[0], error: null },
      });
    } catch (error) {
      dispatch({
        type: SET_MODELO_ATENCION,
        payload: { error: error, data: {} },
      });
    } finally {
      dispatch({
        type: SET_MODELO_ATENCION,
        payload: { isLoading: false },
      });
    }
  };

  const getQuinesSomosBtn = async () => {
    dispatch({
      type: SET_QUIENES_SOMOS_BTN,
      payload: { isLoading: true },
    });

    try {
      const response = await fetchContent('quienessomosbtn');
      if (response?.data?.apiResponse?.code !== 200) return;

      dispatch({
        type: SET_QUIENES_SOMOS_BTN,
        payload: { data: response?.data?.list[0], error: null },
      });
    } catch (error) {
      dispatch({
        type: SET_QUIENES_SOMOS_BTN,
        payload: { error: error, data: {} },
      });
    } finally {
      dispatch({
        type: SET_QUIENES_SOMOS_BTN,
        payload: { isLoading: false },
      });
    }
  };


  const getContacto = () => {
    dispatch({
      type: SET_CONTACTO,
      payload: { isLoading: true },
    });

    const resData = fetchOpcionesAdmin({
      publica: true,
      activa: true,
      tipo: 'BTON_FLOTANTE',
    });

    axios
      .all([resData])
      .then(
        axios.spread((...data) => {

          if ( data[0]?.data?.apiResponse?.code !== 200 ){
              return;
          }

          dispatch({
            type: SET_CONTACTO,
            payload: {
              data: {
                dataAllContact: data[0]?.data?.list ? data[0].data.list : false,
              },
              error: null,
            },
          });
        })
      )
      .catch((error) => {
        dispatch({
          type: SET_CONTACTO,
          payload: {
            error: error,
            data: {
              dataAllContact: [],
              centroContacto: null,
              email: null,
              whatsapp: null,
              sedes: null,
            },
          },
        });
      })
      .finally(() => {
        dispatch({
          type: SET_CONTACTO,
          payload: { isLoading: false },
        });
      });
  };

  return (
    <ApiContext.Provider
      value={{
        noticias,
        laboratorios,
        banners,
        opcionesMenu,
        servicios,
        sedes,
        quienesSomos,
        quienesSomosBtn,
        politicas,
        modeloAtencion,
        contacto,
        getNoticias,
        getLaboratorios,
        getOpcionesMenu,
        getBanners,
        getServicios,
        getSedes,
        getQuienesSomos,
        getQuinesSomosBtn,
        getPoliticas,
        getModeloAtencion,
        getContacto,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};

export default ApiProvider;

ApiProvider.proppTypes = {
  children: PropTypes.element,
};
